import { auth0 } from "@/services/auth0";
import { useClaimStore } from "@/store";
import { ClaimLegalStep } from "@upclaim/sdk/src/data-contracts";

export function computePermissionForCurrentClaim(allowedSteps: ClaimLegalStep["name"] | ClaimLegalStep["name"][]) {
  const claimStep: ClaimLegalStep["name"] = useClaimStore().claim?.claimLegalStep.name;
  if (!claimStep) return false;

  if (!allowedSteps?.length) return true;

  if (typeof allowedSteps === 'string') {
    allowedSteps = [allowedSteps];
  }

  if (allowedSteps.some((step) => step === claimStep)) {
    return true;
  } else {
    return false;
  } 
}

const directive = {
  // called right before the element is inserted into the DOM.
  beforeMount(el, binding, vnode, prevVnode) {
    vnode.el.hidden = !computePermissionForCurrentClaim(binding.value);
  },

  mounted(el, binding) {
    if (!computePermissionForCurrentClaim(binding.value)) {
      el.parentNode?.removeChild(el);
    }
  },

  updated(el, binding) {
    if (!computePermissionForCurrentClaim(binding.value)) {
      el.parentNode?.removeChild(el);
    }
  },
}

export default directive;